module.exports = __webpack_public_path__ + "static/team7-624ad728431af9add0fe35265908c8a5.jpg";